import type { PageHelpContent } from './types';

export const interactionsHelp: PageHelpContent = {
  pageGuide: {
    title: 'Где смотреть подтверждения и обратную связь',
    body: [
      'Здесь видно, как пациенты уже отреагировали на отправленные сообщения.',
      'Во вкладке «Подтверждения» смотрите подтверждение, отмену и перенос записи. Во вкладке «Сбор ОС» смотрите ответы после визита. Во «Все ответы» лежит общий журнал всех действий пациента.',
    ],
  },
  expandedGuide: {
    title: '',
    body: [
      'Сюда попадают ответы из Telegram, MAX, WhatsApp и из ссылок в SMS. Если пациент перешёл по ссылке из SMS, вы увидите отметку okdoc.su.',
      'Проверка обычно выглядит так: сначала в очереди рассылок убеждаемся, что сообщение стало «Отправлено», потом здесь смотрим, ответил ли пациент.',
      'Даты в этом разделе показывают время ответа пациента, а не время создания сообщения в очереди.',
      'Если сообщение отправляли повторно через другой канал, здесь всё равно будет показан тот канал, через который пациент реально ответил.',
    ],
    tips: [
      'Проверяете напоминание о записи — после отправки откройте вкладку «Подтверждения».',
      'Проверяете сбор обратной связи или SMS со ссылкой — смотрите вкладку «Сбор ОС» или «Все ответы».',
    ],
  },
  tooltips: {},
};
